import { Link, useRouteError } from "react-router-dom";
import { routes } from "../routes";

/** Capture les crashes de rendu de tout l'arbre de routes (errorElement racine). */
export default function ErrorPage() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "Erreur inattendue";

  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", gap: 12,
      fontFamily: "'Poppins', system-ui, sans-serif",
    }}>
      <div style={{ fontSize: 18, fontWeight: 600 }}>Quelque chose s'est mal passé</div>
      <div style={{ fontSize: 13, color: "#6b6882" }}>{message}</div>
      <Link to={routes.home()} style={{ fontSize: 13, color: "#303AB2" }}>Retour à l'accueil</Link>
    </div>
  );
}
